import React from "react"
import { useTypedSelector } from "store"
import styled from "styled-components"
import { selectedColorSelector } from "./colorSelectors"

const StyledThreeSixtyIcon = styled.img`
  width: 30px;
  position: absolute;
  top: -25px;
  right: 0;

  ${(p) => p.theme.breakpoints.up("md")} {
    width: 50px;
    top: auto;
    right: auto;
    bottom: 20px;
    left: 20px;
  }
`

const ThreeSixtyIcon = (
  props: React.ComponentProps<typeof StyledThreeSixtyIcon>
) => {
  const selectedColor = useTypedSelector(selectedColorSelector)

  if (!selectedColor || selectedColor.details.images.length <= 1) {
    return null
  }

  return (
    <StyledThreeSixtyIcon
      src="/spin.png"
      alt=""
      title="לחץ וגרור לסובב רכב"
      {...props}
    />
  )
}

export default ThreeSixtyIcon
